// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__3QjZP","background":"NavBar_background__1tI9W","logo":"NavBar_logo__1_l6x","right":"NavBar_right__3Pkxp","claim":"NavBar_claim__raJxK"};